(function () {
  var STORAGE_KEY = 'selected_city';
  var COOKIE_KEY = 'selected_city';
  var COOKIE_DAYS = 365;

  var CITY_CONFIG = {
    jeddah:   { label: 'Jeddah',   variantCity: 'jeddah' },
    makkah:   { label: 'Makkah',   variantCity: 'jeddah' },
    taif:     { label: 'Taif',     variantCity: 'jeddah' },
    medina:   { label: 'Medina',   variantCity: 'jeddah' },

    riyadh:   { label: 'Riyadh',   variantCity: 'riyadh' },
    al_kharj: { label: 'Al Kharj', variantCity: 'riyadh' },

    dammam:   { label: 'Dammam',   variantCity: 'dammam' },
    al_hasa:  { label: 'Al Hasa',  variantCity: 'dammam' },
    jubail:   { label: 'Jubail',   variantCity: 'dammam' }
  };

  function normalizeCity(value) {
    if (!value) return '';
    value = String(value).trim().toLowerCase().replace(/\s+/g, '_');
    return CITY_CONFIG[value] ? value : '';
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return '';
  }

  function getCity() {
    var city = normalizeCity(localStorage.getItem(STORAGE_KEY));
    if (city) return city;

    city = normalizeCity(getCookie(COOKIE_KEY));
    if (city) {
      localStorage.setItem(STORAGE_KEY, city);
      return city;
    }

    return '';
  }

  function setCity(city, options) {
    city = normalizeCity(city);
    if (!city) return;

    localStorage.setItem(STORAGE_KEY, city);
    setCookie(COOKIE_KEY, city, COOKIE_DAYS);

    document.documentElement.setAttribute('data-selected-city', city);
    document.documentElement.setAttribute('data-selected-variant-city', getVariantCity(city));

    document.dispatchEvent(new CustomEvent('city:changed', {
      detail: {
        city: city,
        variantCity: getVariantCity(city),
        reload: !(options && options.reload === false)
      }
    }));
  }

  function getLabel(city) {
    city = normalizeCity(city);
    return city && CITY_CONFIG[city] ? CITY_CONFIG[city].label : '';
  }

  function getVariantCity(city) {
    city = normalizeCity(city);
    return city && CITY_CONFIG[city] ? CITY_CONFIG[city].variantCity : '';
  }

  function getAllCities() {
    return Object.keys(CITY_CONFIG);
  }

  window.CityState = {
    get: getCity,
    set: setCity,
    getLabel: getLabel,
    getVariantCity: getVariantCity,
    validCities: getAllCities(),
    config: CITY_CONFIG
  };

  var initialCity = getCity();
  if (initialCity) {
    document.documentElement.setAttribute('data-selected-city', initialCity);
    document.documentElement.setAttribute('data-selected-variant-city', getVariantCity(initialCity));
  }
})();